import $ from 'jquery';
function Frame(obj, ctx, maxFrame, file, tag) {
    this.stopInterval = null;
    this.w_index = 0;
    this.flag = true;
    this.loadimg = false;
    this.time = 50;
    this.imgArr = [];
    this.loadNum = 0;
    this.obj = obj;
    this.ctx = ctx;
    this.maxFrame = maxFrame;
    this.file = file;
    this.tag = tag;
    this.scrollAble = false;
}

Frame.prototype = {
    constructor: Frame,
    src: function (cb) {
        var _this = this;
        for (let i = 0; i <= _this.maxFrame; i++) {
            _this.imgArr[i] = new Image();
            _this.imgArr[i].onload = function () {
                _this.loadNum++;
                if (_this.loadNum === _this.maxFrame) {
                    console.log('图片加载完成');
                    _this.loadimg = true;
                }
                if (i === 0) {
                    cb();
                }
            }
            _this.imgArr[i].src = require("@/assets/image/gatherers3/" + _this.file + i + ".png");
        }
    },
    walk: function (flag) {
        let _this = this;
        let time = this.time
        _this.w_index++;
        if (_this.w_index > _this.maxFrame) {
            _this.flag = true;
            if (_this.maxFrame === 96 && flag) {
                _this.w_index = 92;
            }else if(_this.maxFrame === 4 && flag) {
                _this.w_index = 0
            } else if (flag) {
                _this.pause();
                _this.w_index = _this.maxFrame;
            } else {
                _this.w_index = 0;
            }
        }
        if (_this.file === 'first/0') {
            const plane1i = $(".pagination1").find("i");
            if (_this.w_index < 10) {
                $(_this.tag).removeClass("pltext-active");
                plane1i.removeClass("planei-active");
            } else if (_this.w_index >= 10 && _this.w_index < 30) {
                $(_this.tag[0]).addClass("p1text-active").siblings().removeClass("p1text-active");
                plane1i.eq(0).addClass("planei-active").siblings().removeClass("planei-active");
            } else if (_this.w_index >= 30 && _this.w_index < 58) {
                $(_this.tag[1]).addClass("p1text-active").siblings().removeClass("p1text-active");
                plane1i.eq(1).addClass("planei-active").siblings().removeClass("planei-active");
            } else if (_this.w_index >= 58 && _this.w_index < 93) {
                $(_this.tag[2]).addClass("p1text-active").siblings().removeClass("p1text-active");
                plane1i.eq(2).addClass("planei-active").siblings().removeClass("planei-active");
            } else if (_this.w_index >= 93 && _this.w_index < 135) {
                $(_this.tag[3]).addClass("p1text-active").siblings().removeClass("p1text-active");
                plane1i.eq(3).addClass("planei-active").siblings().removeClass("planei-active");
            } 
            if(_this.w_index > 130 || _this.maxFrame < 130) {
                _this.scrollAble = true
            }
            if([29, 57, 92, 124].indexOf(_this.w_index) > -1) {
                time = 15 * _this.time
            }
        }
        _this.ctx.clearRect(0, 0, _this.obj.width, _this.obj.height);
        _this.ctx.drawImage(_this.imgArr[_this.w_index], 0, 0, _this.obj.width, _this.obj.height)

        this.stopInterval = setTimeout(() => {
            _this.walk(flag)
        }, time)
    },
    pause: function () {
        var _this = this;
        clearTimeout(_this.stopInterval);
    }
}
export {
    Frame
}
